export default __webpack_public_path__ + "static/media/HOW TO PLAY.65800391.PNG";